import { render } from "./PayLater.vue?vue&type=template&id=4b675cc3&scoped=true&ts=true"
import script from "./PayLater.vue?vue&type=script&lang=ts"
export * from "./PayLater.vue?vue&type=script&lang=ts"

import "./PayLater.vue?vue&type=style&index=0&id=4b675cc3&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b675cc3"]])

export default __exports__